import React from "react";
import { Form } from "../../libs/mobx-react-form";

const FormContext = React.createContext(new Form());

export default FormContext;
